import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { useFragmentGridContext } from '../../fragments-grid/FragmentGridContext';
import { FragmentCardBase } from '../base/FragmentCardBase';
import { useStablePoster } from '../hooks/useStablePoster';
import { VideoFragmentCardList } from './VideoFragmentCardList';
import { VideoFragmentMedia } from './VideoFragmentMedia';

/**
 * Card for a video fragment: poster, overlay (date + duration), title,
 * platform icons (green if completed, warning otherwise), footer (UserLabel + relative date).
 * Uses stable poster URIs so the same URL is kept for the session and the browser can serve from cache.
 * Renders list layout when viewMode is 'list', grid layout otherwise.
 */
export function VideoFragmentCard({ fragment }: { fragment: FragmentListItemDto }) {
  const { breakpointsUp, viewMode } = useFragmentGridContext();
  const { isMd, isXl } = breakpointsUp;
  const stablePoster = useStablePoster(fragment);

  const variant = fragment.poster ? (isXl ? 'h720' : isMd ? 'h360' : 'h180') : null;

  const posterSrc = variant && stablePoster ? stablePoster[variant] : null;

  if (viewMode === 'list') {
    return <VideoFragmentCardList fragment={fragment} posterSrc={posterSrc} variant={variant} />;
  }

  return (
    <FragmentCardBase
      fragment={fragment}
      media={<VideoFragmentMedia fragment={fragment} posterSrc={posterSrc} variant={variant} />}
    />
  );
}
